import { apiUrl } from '../utils/constants';
import { GET, PATCH } from './api.service.wrapper';




export const GetFeedback = async (
        keyword = '', 
        page = '', 
        perPage = '', 
        status = null
        // is_paginate = 1, 
        // status = null
    ) => {
        let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['question'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }
    // params['paginate'] = is_paginate;

    const response = await GET(apiUrl.feedback, params);
    return response;
}

export const GetFeedbackById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.feedback + '/' + id,params);
    return response;
}

export const UpdateFeedbackStatus = async (id, data) => {
    const response = await PATCH(apiUrl.feedback + '/' + id, data);
    return response
}